export default __webpack_public_path__ + "static/media/dapps.38678ef4.jpg";